import type {SVGProps} from 'react'
const BrandReturnPackageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 100 100"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      stroke="#2d2e2c"
      strokeWidth={1.5}
      d="M86.249 42.822v14.375L49.051 77.541 12.75 57.203V42.83l37.473-18.986z"
    />
    <path
      stroke="#2d2e2c"
      strokeDasharray="2.31 1.15"
      strokeWidth={0.5}
      d="m49.025 77.406.022-16.176"
    />
    <path stroke="#2d2e2c" d="m85.924 42.825-36.863 18.87-35.985-18.87" />
    <path
      fill="#2d2e2c"
      d="m39.66 47.527 10.404-1.885-7.816-3.729zm26.348-15.211-.677-.323L44.829 43.83l.677.322.677.323L66.685 32.64z"
    />
  </svg>
)
export {BrandReturnPackageIcon}
